export interface CreateAverageMonthlyIncome {
    countryCode: string;
    income: number;
}

export class CreateAverageMonthlyIncomeFactory{
    static create(): CreateAverageMonthlyIncome {
        return {
            countryCode: "",
            income: 0,
        }
    }
}

enum CreateAverageMonthlyIncomeKeys {
    CountryCode = "countryCode",
    Income = "income",
}

export function CreateAverageMonthlyIncomeObject() {
    return {
        CountryCode: CreateAverageMonthlyIncomeKeys.CountryCode,
        Income: CreateAverageMonthlyIncomeKeys.Income,
    }
}

export function CreateEmptyAverageMonthlyIncomeErrorsObject(): { [key: string]: boolean } {
    return {
        [CreateAverageMonthlyIncomeKeys.CountryCode]: false,
        [CreateAverageMonthlyIncomeKeys.Income]: false,
    };
}
